import { FC } from 'react';
import { Stack, SvgIcon } from '@mui/material';

import StarFilledSvg from '../../icons/starFilled.svg';
import StarStrokeSvg from '../../icons/starStroke.svg';

import { StarSlot } from './MplRatingV2.styled';

const STARS = [1, 2, 3, 4, 5] as const;

const DEFAULT_STAR_SIZE = 24;

/** 0 means nothing picked yet */
export type TRatingValue = 0 | typeof STARS[number];

interface IMplRatingV2Props {
	value: TRatingValue;
	onChange?: (rating: TRatingValue) => void;
	/** Renders the stars as a non-interactive summary of {value}. */
	readOnly?: boolean;
	/** Star edge length in px. */
	starSize?: number;
	testId?: string;
}

export const MplRatingV2: FC<IMplRatingV2Props> = ({
	value,
	onChange,
	readOnly = false,
	starSize = DEFAULT_STAR_SIZE,
	testId = 'mplRatingV2',
}) => (
	<Stack direction="row" gap={1} data-testid={testId}>
		{STARS.map((star) => {
			const isFilled = star <= value;

			return (
				<StarSlot
					key={star}
					type="button"
					disabled={readOnly}
					onClick={() => onChange?.(star)}
					data-testid={`${testId}-star-${star}`}
				>
					<SvgIcon
						component={isFilled ? StarFilledSvg : StarStrokeSvg}
						sx={{ fontSize: starSize }}
					/>
				</StarSlot>
			);
		})}
	</Stack>
);
